module.exports = __webpack_public_path__ + "img/pm.89993b1f.svg";